import React, { useEffect, useRef } from "react";
import "./ButterflyLottie.scss";

const ButterflyLottie = () => {
  const butterflyRef = useRef(null);
  const animationRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const isFlying = useRef(false);

  const position = useRef({ x: 100, y: 100 });

  const startFlying = () => {
    if (isFlying.current) return;
    isFlying.current = true;

    if (butterflyRef.current) {
      butterflyRef.current.classList.add("fluttering");
      butterflyRef.current.classList.remove("landed");
      butterflyRef.current.style.transition = "none";
    }

    position.current = {
      x: Math.random() * (window.innerWidth - 100),
      y: window.scrollY + Math.random() * window.innerHeight,
    };

    animate();
  };

  const animate = () => {
    const speed = 0.05;

    const ref = butterflyRef.current;
    if (!ref) return;

    const currentX = parseFloat(ref.style.left || "0");
    const currentY = parseFloat(ref.style.top || "0");

    const dx = position.current.x - currentX;
    const dy = position.current.y - currentY;

    const newX = currentX + dx * speed;
    const newY = currentY + dy * speed;

    ref.style.left = `${newX}px`;
    ref.style.top = `${newY}px`;

    animationRef.current = requestAnimationFrame(animate);
  };

  const landButterfly = () => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    isFlying.current = false;

    if (butterflyRef.current) {
      const landingX = Math.random() * (window.innerWidth - 100);
      const landingY = window.scrollY + window.innerHeight / 2;

      butterflyRef.current.style.transition = "top 1s ease, left 1s ease";
      butterflyRef.current.style.left = `${landingX}px`;
      butterflyRef.current.style.top = `${landingY}px`;

      butterflyRef.current.classList.remove("fluttering");
      butterflyRef.current.classList.add("landed");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      startFlying();
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        landButterfly();
      }, 500);
    };

    window.addEventListener("scroll", handleScroll);
    landButterfly();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      cancelAnimationFrame(animationRef.current);
      clearTimeout(scrollTimeoutRef.current);
    };
  }, []);

  return (
    <img
      ref={butterflyRef}
      className="butterfly landed"
      src="https://i.pinimg.com/originals/9a/fd/3e/9afd3e28fafe772c1b8634f3b039f2e1.gif"
      alt="Butterfly"
    />
  );
};

export default ButterflyLottie;
